"use strict";

exports.__esModule = true;
exports.Landing = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _admin = _interopRequireDefault(require("../../../assets/vimana/admin.svg"));
var _dashboard = _interopRequireDefault(require("../../../assets/vimana/dashboard.svg"));
var _poweredByVimana = _interopRequireDefault(require("../../../assets/vimana/powered-by-vimana.png"));
var _RestAPI = require("../API/RestAPI");
var _whenModern = require("../Theme/UiDesign/whenModern");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LandingWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Landing__LandingWrapper",
  componentId: "sc-xkcicz-0"
})(["width:100%;height:100%;background:", ";overflow:hidden;"], function (props) {
  return props.theme.LandingBackground;
});
var PlantName = _styledComponents["default"].div.withConfig({
  displayName: "Landing__PlantName",
  componentId: "sc-xkcicz-1"
})(["margin-left:12%;color:", ";font-size:", ";", ""], function (props) {
  return props.theme.LandingAppIconColor;
}, function (props) {
  return props.theme.fontSizeLarge;
}, (0, _whenModern.whenModern)("font-weight: 700;"));
var LandingPageLogo = _styledComponents["default"].div.withConfig({
  displayName: "Landing__LandingPageLogo",
  componentId: "sc-xkcicz-2"
})(["max-width:490px;text-align:center;margin:auto;margin-bottom:20px;"]);
var PoweredBy = _styledComponents["default"].div.withConfig({
  displayName: "Landing__PoweredBy",
  componentId: "sc-xkcicz-3"
})(["color:", ";position:absolute;bottom:15px;right:0%;"], function (props) {
  return props.theme.LandingAppIconColor;
});
var AppsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Landing__AppsWrapper",
  componentId: "sc-xkcicz-4"
})(["height:100%;width:100%;display:flex;align-items:center;"]);
var AppBody = _styledComponents["default"].div.withConfig({
  displayName: "Landing__AppBody",
  componentId: "sc-xkcicz-5"
})(["display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;"]);
var AppWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Landing__AppWrapper",
  componentId: "sc-xkcicz-6"
})(["width:33.33%;display:inline-block;margin:20px 0px;&:hover{transform:scale(1.3);transition:all 250ms;}a{text-decoration:none;}"]);
var NameWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Landing__NameWrapper",
  componentId: "sc-xkcicz-7"
})(["text-align:center;color:", ";font-size:", ";"], function (props) {
  return props.theme.LandingAppIconColor;
}, function (props) {
  return props.theme.fontSizeLarge;
});
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "Landing__IconContainer",
  componentId: "sc-xkcicz-8"
})(["margin:auto;text-align:center;transform:scale(1);img{width:72px;}"]);
var VerticalCenter = _styledComponents["default"].div.withConfig({
  displayName: "Landing__VerticalCenter",
  componentId: "sc-xkcicz-9"
})(["width:100%;align-items:center;max-width:900px;margin:auto;"]);
var PlantNameWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Landing__PlantNameWrapper",
  componentId: "sc-xkcicz-10"
})(["display:flex;justify-content:space-between;align-items:center;transform:scale(1.3);margin-top:10px;"]);
var appIcons = {
  admin: _admin["default"],
  dashboard: _dashboard["default"]
};
function App(_ref) {
  var name = _ref.name,
    url = _ref.url,
    icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement(IconContainer, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: url
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: name,
    src: appIcons[icon]
  }), /*#__PURE__*/_react["default"].createElement(NameWrapper, null, name))));
}
var Landing = exports.Landing = (0, _styledComponents.withTheme)(function (props) {
  var showPoweredBy = props.showPoweredBy,
    name = props.name,
    apps = props.apps,
    theme = props.theme,
    SettingsMenu = props.settingsMenu;
  var _React$useContext = _react["default"].useContext(_RestAPI.RestAPIContext),
    plantName = _React$useContext.plantName;
  return /*#__PURE__*/_react["default"].createElement(LandingWrapper, null, /*#__PURE__*/_react["default"].createElement(PlantNameWrapper, null, /*#__PURE__*/_react["default"].createElement(PlantName, null, plantName), SettingsMenu ? /*#__PURE__*/_react["default"].createElement(SettingsMenu, null) : null), /*#__PURE__*/_react["default"].createElement(AppsWrapper, null, /*#__PURE__*/_react["default"].createElement(VerticalCenter, null, /*#__PURE__*/_react["default"].createElement(LandingPageLogo, null, /*#__PURE__*/_react["default"].createElement("img", {
    src: theme.LandingLogo.slice(4, -1),
    alt: name
  })), /*#__PURE__*/_react["default"].createElement(AppBody, null, apps.map(function (app) {
    return /*#__PURE__*/_react["default"].createElement(AppWrapper, {
      key: app.name
    }, /*#__PURE__*/_react["default"].createElement(App, app));
  })))), /*#__PURE__*/_react["default"].createElement(PoweredBy, null, showPoweredBy ? /*#__PURE__*/_react["default"].createElement("img", {
    src: _poweredByVimana["default"],
    alt: "Powered by VIMANA"
  }) : null));
});